import React, { Fragment } from 'react';
import { User } from '../model/Model';
import { Link } from 'react-router-dom';

export class NavBar extends React.Component<{
  user: User | undefined;
}> {
  render() {
    let loginLogOut: any;
    if (this.props.user) {
      loginLogOut = (
        <Link
          data-testid="logout-link"
          to="/logout"
          style={{ float: 'right', marginRight: '5px' }}>
          {this.props.user.userName}
        </Link>
      );
    } else {
      loginLogOut = (
        <Link
          data-testid="logout-link"
          to="/login"
          style={{ float: 'right', marginRight: '5px' }}>
          Login
        </Link>
      );
    }
    return (
      <nav className="navbar">
        <Link data-testid="home-link" to="/">
          Home
        </Link>
        <Link data-testid="profile-link" to="/profile">
          Profile
        </Link>
        <Link data-testid="spaces-link" to="/spaces">
          Spaces
        </Link>
        {loginLogOut}
      </nav>
    );
  }
}
